<template>
  <modal
    name="collectAccountInfo"
    modal-style="compact"
    :display-header-title="false"
    :is-required="true"
  >
    <cf-collect-account-info />
  </modal>
</template>


<script>
  import CfCollectAccountInfo from '@/view/components/globals/cf-collect-account-info/index.vue';

  export default {
    name: 'CollectAccountInfoModal',

    components: {
      CfCollectAccountInfo
    }
  };
</script>
